"use client"
import { Container } from "@/components/common/container"
import { useCart } from "@/queries/useCart"
import { useRef } from "react"
import { DeviceDetailedSecx } from "./device-detail-secx"
import DynamicDeviceSecx from "./device-secx.wrapper"
import FaqWrapper from "./faq.wrapper"
import { ReviewsSecx } from "./review-secx"
import { SimilarProducts } from "./similar-products"

interface ProductPageProps {
  id: string
}

function Products({ id, data }: ProductPageProps & { data: any }) {
  const ref = useRef<HTMLDivElement | null>(null)

  const deviceDetailsRef = useRef(null) // Create a ref

  // Function to scroll to DeviceDetailedSecx
  const scrollToDetails = () => {
    if (deviceDetailsRef.current) {
      // @ts-expect-error css error
      deviceDetailsRef.current.scrollIntoView({ behavior: "smooth" })
    }
  }

  const { data: cart } = useCart()

  return (
    <>
      <Container ref={ref}>
        <DynamicDeviceSecx
          data={data}
          cart={cart!}
          onClick={scrollToDetails}
          id={id}
        />
        <div ref={deviceDetailsRef}>
          <DeviceDetailedSecx data={data?.products?.[0]} />
        </div>
        {/* <SimilarProducts data={data?.products?.[0]?.similarProducts} /> */}
        <ReviewsSecx data={data?.products?.[0]} />
        <FaqWrapper />
      </Container>
    </>
  )
}

export default Products
